import BalanceApi from '../api'
import BalanceDocumentToolbar from '../components/BalanceDocumentToolbar'
import BalanceDocumentTable from '../components/BalanceDocumentTable'
import BalanceDocumentList from '../components/BalanceDocumentList'
import Loading from '@/components/helpers/Loading'
import emptyTable from '@/components/helpers/EmptyTable'

export default {
  components: {
    BalanceDocumentToolbar,
    BalanceDocumentTable,
    BalanceDocumentList,
    Loading,
    emptyTable
  },
  data () {
    return {
      id: '',
      document: {
        created_on: '',
        summa: '',
        records: []
      },
      loading: false
    }
  },
  computed: {
    documentSumma () {
      let summa = 0
      this.document.records.forEach(function (v) {
        summa += parseFloat(v.tsena) * parseInt(v.kolichestvo)
      })

      return summa
    },
    itemsDisplayComponent () {
      return this.$vuetify.breakpoint.smAndDown ? `balance-document-list` : `balance-document-table`
    }
  },
  methods: {
    async openDocument () {
      this.loading = true
      let response = await BalanceApi.openDocument({ id: this.id, name: this.name })
      if (response.success) {
        this.document = response.document
      } else {
        console.log(response.error)
      }
      this.loading = false
    }
  },
  beforeMount () {
    this.id = this.$route.params.docId
    this.openDocument()
  }
}
